import { createReducer, Action, on } from '@ngrx/store';
import * as Actions from './wellness.actions';
import { initialState, State } from './wellness.state';
import * as Adapters from './wellness.adapters';
import { API } from '@app/core/models';
import moment from 'moment';

const inboxReducer = createReducer(
  initialState,
  on(Actions.initializeCompletionReportPage, (state) => ({
    ...state,
    api: {
      ...state.api,
      getTeamWellnessChecksHotels: API.LoadingState.LOADING,
    },
  })),
  on(Actions.initializeTeamRisksPage, (state) => ({
    ...state,
    api: {
      ...state.api,
      getTeamWellnessChecksHotels: API.LoadingState.LOADING,
    },
  })),
  on(Actions.getTeamWellnessCheckInHotelsSuccess, (state, { hotels }) => ({
    ...state,
    hotels,
    api: {
      ...state.api,
      getTeamWellnessChecksHotels: API.LoadingState.LOADED,
    },
  })),
  on(Actions.getTeamWellnessCheckInReport, (state) => ({
    ...state,
    api: {
      ...state.api,
      getTeamWellnessCheckInReport: API.LoadingState.LOADING,
    },
  })),
  on(Actions.getTeamWellnessCheckInReportSuccess, (state, { report }) => ({
    ...state,
    completionReports: Adapters.completionReports.upsertOne(
      report,
      state.completionReports,
    ),
    api: {
      ...state.api,
      getTeamWellnessCheckInReport: API.LoadingState.LOADED,
    },
  })),
  on(Actions.getTeamWellnessCheckInRisks, (state) => ({
    ...state,
    api: {
      ...state.api,
      getTeamWellnessCheckInRisks: API.LoadingState.LOADING,
    },
  })),
  on(Actions.getTeamWellnessCheckInRisksSuccess, (state, { risks }) => ({
    ...state,
    risks,
    api: {
      ...state.api,
      getTeamWellnessCheckInRisks: API.LoadingState.LOADED,
    },
  })),
  on(Actions.setTeamRisksMenuSelection, (state, { entId }) => ({
    ...state,
    menu: {
      ...state.menu,
      entId,
      date: state.menu ? state.menu.date : moment().format(),
    },
  })),
  on(Actions.setCompletionReportMenuSelection, (state, { entId, date }) => ({
    ...state,
    menu: {
      ...state.menu,
      entId,
      date,
    },
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return inboxReducer(state, action);
}
